var hardwareList = (function () {
    const init = function () {
        $.fn.dataTableExt.oSort["version-desc"] = function (x, y) {
          const x_version = $(x).text().split('.');
          const y_version = $(y).text().split('.');
          if (parseInt(x_version[0]) > parseInt(y_version[0])) {
            return -1;
          }
          if (parseInt(x_version[1]) > parseInt(y_version[1])) {
            return -1;
          }
          if (parseInt(x_version[2]) > parseInt(y_version[2])) {
            return -1;
          }
          return 1;
        };
        $.fn.dataTableExt.oSort["version-asc"] = function (x, y) {
          const x_version = $(x).text().split('.');
          const y_version = $(y).text().split('.');
          if (parseInt(x_version[0]) > parseInt(y_version[0])) {
            return 1;
          }
          if (parseInt(x_version[1]) > parseInt(y_version[1])) {
            return 1;
          }
          if (parseInt(x_version[2]) > parseInt(y_version[2])) {
            return 1;
          }
          return -1;
        };
        $('#hardwares-datatable').DataTable({
            autoWidth: false,
            responsive: true,
            columnDefs: [
                { type: "version", "className": 'version-column', targets: 0 },
                { className: 'description-column', targets: 1 },
                { className: 'dispensers-count-column', targets: 2 },
                { className: 'firmwares-count-column', targets: 3 },
                { className: 'hardware-actions-column desktop', targets: 4 },
                { orderable: false, targets: 4 }
            ],
            order: [[ 0, "desc" ]],
            language: {
                url: 'https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json'
                //TODO: make it depends on current culture not on sdn call
            }
        });

        $('#hardwares-datatable')
            .on('click', '.mdi-delete', function () {
                const id = $(this).data('hardware-id');
                const version = $(this).data('hardware-version');
                $('#hardware-version-to-delete').text(version);
                $('#delete-hardware-button').attr('data-hardware-id', id);
            });

        $('#delete-hardware-button').on('click',
            function () {
                const hardwareIdToDelete = $(this).data('hardware-id');
                sendDeleteRequest(hardwareIdToDelete);
            });

        function sendDeleteRequest(id) {
            $.ajax({
                    url: `/Hardwares/Delete/${id}`,
                    method: 'DELETE',
                    contentType: 'application/json'
                })
                .done(function (data) {
                    $('#delete-modal').modal('hide');
                    $.showNotification(data.header, data.message, data.succeed);
                });
        }
    };

    return {
        init: init
    };

})();
